<template>
  <div :style="{height: tableHeight + 'px'}">
    <div class="main-box">
      <div class="div-tit">执行预约流程</div>
      <div class="flow-box">
          <button :class="[isActive1 ? 'but' : 'but1']" @click="onButton(1)">到场登记</button>
          <button :class="[isActive2 ? 'but' : 'but1']" @click="onButton(2)">进 厂</button>
          <button :class="[isActive3 ? 'but' : 'but1']" @click="onButton(3)">出 厂</button>
      </div>

      <el-form ref="form" :model="form" >
        <el-form-item label="扫码信息">
          <el-input ref="input" v-model="form.number" autofocus @keyup.enter="onSubmit" class="width4"></el-input>
        </el-form-item>
        <!-- <el-form-item >
          <el-button type="primary" @click="onSubmit">创建</el-button>
          <el-button @click="form.number = ''">取消</el-button>
        </el-form-item> -->
      </el-form>

      <div class="card-box">
        <el-card class="box-card">
          <template #header>
            <div class="card-header">
              到场登记车辆
            </div>
          </template>
          <div v-for="(itme, index) in flowList1" :key="index" class="list-item">
            <label>{{index+1}}. {{itme.vehicle}}（{{itme.linkman}}）</label>
            <span>{{itme.stateName}} {{itme.execTime}}</span>
          </div>
        </el-card>
        <el-card class="box-card">
          <template #header>
            <div class="card-header">
              进厂车辆
            </div>
          </template>
          <div v-for="(itme, index) in flowList2" :key="index" class="list-item">
            <label>{{index+1}}. {{itme.vehicle}}（{{itme.linkman}}）</label>
            <span>{{itme.stateName}} {{itme.execTime}}</span>
          </div>
        </el-card>
        <el-card class="box-card">
          <template #header>
            <div class="card-header">
              出厂车辆
            </div>
          </template>
          <div v-for="(itme, index) in flowList3" :key="index" class="list-item">
            <label>{{index+1}}. {{itme.vehicle}}（{{itme.linkman}}）</label>
            <span>{{itme.stateName}} {{itme.execTime}}</span>
          </div>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'execflow',
  data () {
    return {
      isActive1: true,
      isActive2: false,
      isActive3: false,
      step: '1',
      // 扫司机二维码（预约Id和车辆Id）
      form: {
        number: ''
      },
      // 到场登记
      flowList1: [],
      // 进厂
      flowList2: [],
      // 出厂
      flowList3: []
    }
  },
  // 接收父组件传值
  props: ['clientHeight'],
  mounted () {
    this.qx = this.$route.params.qx
    // const ui = this.$api.ui
    // if (ui == null) {
    //   this.$router.push({ path: '/login' })
    // }
    this.getTableHeight()
    // this.$route.params.sid this.$route.query.sid
    this.$nextTick(() => {
      this.$refs.input.focus()
    })
    this.flowList(1)
    this.flowList(2)
    this.flowList(6)
  },
  methods: {
    inputfocus () {
      this.$nextTick(() => {
        this.form.number = ''
        this.$refs.input.focus()
      })
    },
    onButton (val) {
      this.isActive1 = false
      this.isActive2 = false
      this.isActive3 = false
      if (val === 1) {
        this.isActive1 = true
        this.step = 1
        this.inputfocus()
      } else if (val === 2) {
        this.isActive2 = true
        this.step = 2
        this.inputfocus()
      } else if (val === 3) {
        this.isActive3 = true
        this.step = 6
        this.inputfocus()
      }
    },
    async onSubmit () {
      // console.log('this.step=', this.step)
      console.log('form.number=', this.form.number)
      if (this.form.number === '') {
        this.$message.error('扫码为空，请重新扫码。')
      }
      const params = '?qrcode=' + this.form.number + '&step=' + this.step
      const { data: ret } = await this.$http.post(this.$api.reserveflowstate + params)
      if (ret.status === 0) {
        this.flowList(this.step)
        this.$message.success(ret.message)
      } else {
        this.$message.error(ret.message)
      }
    },
    // stp 流程环节
    async flowList (stp) {
      // state 1:待执行/2:已完成 0:不限
      var state = 2
      // 环节1:到场登记,state=0
      if (stp === 1) {
        state = 0
      }
      const params = '?step=' + stp + '&state=' + state
      const { data: ret } = await this.$http.get(this.$api.reserveflowlistbystep + params)
      // console.log('ret=', ret)
      if (stp === 1) {
        this.flowList1 = ret
      } else if (stp === 2) {
        this.flowList2 = ret
      } else if (stp === 6) {
        this.flowList3 = ret
      }
    },
    getTableHeight () {
      this.tableHeight = this.clientHeight - 88 - 42 - 35
    }
  },
  watch: {
    clientHeight: function (val) {
      this.getTableHeight()
    }
  }
}
</script>

<style lang="less" scoped>
.main-box {
  margin: 0 20px 20px 20px;
}
.flow-box{
  display: flex;
  justify-content:space-evenly;
  align-items: center;
  // border: 2px solid #f00;
  button {
    border-radius: 15px;
    width: 220px;
    height: 120px;
    color: #fff;
    font-size: 24px;
    text-align: center;
    line-height: 120px;
    border: 2px solid #eee;
    cursor: pointer;
  }
  .but {
      background-color: #409EFF;
    }
  .but1 {
    background-color: #909399;
  }
}

.card-box{
  display: flex;
  justify-content: space-between;
  align-items:stretch;
}
.card-header {
  font-weight: bold;
}
.box-card {
  display: inline-block;
  // margin: 10px;
  width: 32%;
  // width: 350px;
}
.list-item{
  padding: 5px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: dashed 1px   #eee;
  label {
    color: #000;
    overflow: hidden;
  }
  span{
    color: #999;
    overflow: hidden;
  }
}
</style>
